module.exports = __webpack_public_path__ + "static/img/image_recruit_07.d9cd679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_07.png
// module id = AUeK
// module chunks = 10